import axios from "axios";
import Const from "../../../utils/const";

/**
 * 不放在公共api文件夹中是因为这个请求处理方法与项目通用方式的不一样
 * 返回结果不能额外处理，在实际应用中拿到结果和结果不符合预期都有相应的处理，无法一概而论
 * 另外API转发不通过spt助手后端转发，直接使用nginx代理
 */

export default function Req(params) {
	return new Promise((resolve, reject) => {
		const instance = axios.create({
			timeout: 30000,
			method: "post"
		});

		instance.interceptors.request.use(
			config => {
				return config;
			},
			error => {
				error.msg = error.props || Const.PARAMS_ERROR;
				return Promise.reject(error);
			}
		);

		instance.interceptors.response.use(
			res => {
				return res;
			},
			error => {
				error.msg = error.props || Const.HTTPRES_ERROR;
				return Promise.reject(error);
			}
		);

		instance(params)
			.then(res => {
				resolve(res.data);
			})
			.catch(error => {
				error.msg = error.props || Const.PARAMS_ERROR;
				reject(error);
			});
	});
}
